module.exports = __webpack_public_path__ + "static/media/upload.8d77e2c0.svg";